import { get } from 'lodash';
import { ENTITY_TYPE, FLOW_TYPE, PATHS, PROCESS_STATUS, PROCESS_STATUS_PAGES } from 'consts';

export function getPageForStatus(
	status = PROCESS_STATUS.None,
	flowType = FLOW_TYPE.MV,
	entityType = ENTITY_TYPE.INDIVIDUAL
) {
	const path = `${status}.${flowType}.${entityType}`;
	return get(PROCESS_STATUS_PAGES, path, [PATHS.ONBOARD])[0];
}

export function getNextPage(
	status = PROCESS_STATUS.None,
	flowType = FLOW_TYPE.MV,
	entityType = ENTITY_TYPE.INDIVIDUAL
) {
	const path = `${status}.${flowType}.${entityType}`;
	const pages = get(PROCESS_STATUS_PAGES, path, [PATHS.ONBOARD]);
	const pageName = getPageName();
	const index = pages.indexOf(pageName);
	const nextPage = pages[index + 1];

	if (!nextPage) {
		console.error('Next page is not defined:', nextPage);
		return null;
	}

	return nextPage;
}

function getPageName() {
	const arr = window.location.pathname.split('/');
	return arr.length ? arr[arr.length - 1] : '';
}
